import { useContext, useEffect, useRef, useState } from 'react';
import type { TRect, TSize } from '@src/types/misc';
import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';

export function calculateLocationInViewbox(percentages: TRect, viewbox: TSize) {
  return {
    height: percentages.height * viewbox.height,
    width: percentages.width * viewbox.width,
    x: percentages.x * viewbox.width,
    y: percentages.y * viewbox.height
  };
}

function isRect(maybeRect: TRect | Record<string, never>): maybeRect is TRect {
  return maybeRect.hasOwnProperty('x');
}

function useLocationInViewbox(
  location: TRect | Record<string, never>
): TRect | Record<string, never> {
  const { viewbox } = useContext(WysiwygEditorStateContext);
  const initializedRef = useRef(false);

  const [locationInViewbox, setLocationInViewbox] = useState<
    TRect | Record<string, never>
  >(isRect(location) ? calculateLocationInViewbox(location, viewbox) : {});

  useEffect(() => {
    if (!initializedRef.current) {
      initializedRef.current = true;
      return;
    }

    if (isRect(location)) {
      setLocationInViewbox(calculateLocationInViewbox(location, viewbox));
    } else {
      setLocationInViewbox({});
    }
  }, [location, viewbox]);

  return locationInViewbox;
}

export default useLocationInViewbox;
